export const utf8ToBase64 = (string: string) => window.btoa(encodeURIComponent(string));

export const base64ToUtf8 = (string: string) => {
  return decodeURIComponent(window.atob(string));
};
